import { ref, onUnmounted } from "vue";

export function useBodyDimensions() {
    const observer = new ResizeObserver(setBodyDimensionsPixels);

    const width = ref(0);
    const height = ref(0);

    function observe(element: HTMLElement) {
        observer.disconnect();
        observer.observe(element);
    }

    function setBodyDimensionsPixels(entries: ResizeObserverEntry[]) {
        if (entries.length === 0) {
            return;
        }

        const { contentRect } = entries[0]!;

        width.value = contentRect.width;
        height.value = contentRect.height;
    }

    onUnmounted(() => {
        observer.disconnect();
    });

    return {
        width,
        height,
        observe
    };
}
